module.exports = __webpack_public_path__ + "static/media/John@2x.10d05e6a.jpg";